var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.501C22 17.6437 18.418 21.0021 14 21.0021C13.2077 21.0032 12.4186 20.893 11.653 20.6742C11.069 20.9913 9.728 21.6 7.472 21.9965C7.272 22.0308 7.12 21.8079 7.199 21.6086C7.553 20.7127 7.873 19.519 7.969 18.4303C6.744 17.1122 6 15.387 6 13.501C6 9.35832 9.582 6 14 6C18.418 6 22 9.35832 22 13.501ZM10.5 10.2863C10.3674 10.2863 10.2402 10.3428 10.1464 10.4432C10.0527 10.5437 10 10.68 10 10.8221C10 10.9642 10.0527 11.1005 10.1464 11.2009C10.2402 11.3014 10.3674 11.3579 10.5 11.3579H17.5C17.6326 11.3579 17.7598 11.3014 17.8536 11.2009C17.9473 11.1005 18 10.9642 18 10.8221C18 10.68 17.9473 10.5437 17.8536 10.4432C17.7598 10.3428 17.6326 10.2863 17.5 10.2863H10.5ZM10.5 12.9652C10.3674 12.9652 10.2402 13.0217 10.1464 13.1222C10.0527 13.2227 10 13.3589 10 13.501C10 13.6431 10.0527 13.7794 10.1464 13.8799C10.2402 13.9804 10.3674 14.0368 10.5 14.0368H17.5C17.6326 14.0368 17.7598 13.9804 17.8536 13.8799C17.9473 13.7794 18 13.6431 18 13.501C18 13.3589 17.9473 13.2227 17.8536 13.1222C17.7598 13.0217 17.6326 12.9652 17.5 12.9652H10.5ZM10.5 15.6442C10.3674 15.6442 10.2402 15.7006 10.1464 15.8011C10.0527 15.9016 10 16.0379 10 16.18C10 16.3221 10.0527 16.4583 10.1464 16.5588C10.2402 16.6593 10.3674 16.7158 10.5 16.7158H14.5C14.6326 16.7158 14.7598 16.6593 14.8536 16.5588C14.9473 16.4583 15 16.3221 15 16.18C15 16.0379 14.9473 15.9016 14.8536 15.8011C14.7598 15.7006 14.6326 15.6442 14.5 15.6442H10.5Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon3);
export default __webpack_public_path__ + "static/media/messageIcon3.ccd14ff32410f71d119196c18a3b3a1f.svg";
export { ForwardRef as ReactComponent };